import Box from '@mui/material/Box';
import { Modal, ModalHeader } from '@repo/ui';
import { useIsMobile } from '@repo/mui-config/hooks';

import type { ModalProps } from '../display-modal';
import { ModalContent } from '../modal-content';
import { useModalStore } from '../modal.store';

export function ModalPromotionCodeError({ modalState, isModalOpen, closeModal }: ModalProps) {
  const isMobile = useIsMobile();
  const { additionalProps } = useModalStore();

  const handleClose = () => {
    (additionalProps.onClose as (() => void) | undefined)?.();
    closeModal();
  };

  return (
    <Modal isOpen={isModalOpen} maxWidth="xs">
      <Box sx={{ py: 4, px: isMobile ? '20px' : '44px' }}>
        <ModalHeader
          centeredLogo={true}
          closeButton={{ isVisible: true, onClick: handleClose }}
          sx={{ mb: '20px' }}
        />
        <ModalContent modalType={modalState} />
      </Box>
    </Modal>
  );
}
